
import { ConfigSlim, ConfigSlimStep } from "@/types/configuration"
import React, { ReactElement, useState } from "react"
import WithAuthRegistrationComponent from "./with_auth_registration_component"
import WithAuthLoginComponent from "./with_auth_login_component"

interface Props {
    texts: any
    locale: string
    configInfo: ConfigSlim
    configStep: ConfigSlimStep
    goToFreePath: () => void
    tenantMessageElement?: ReactElement
}

const WithAuthComponent = ({ locale, texts, configInfo, goToFreePath, tenantMessageElement }: Props) => {

    enum PageView {
        LOGIN = 0,
        REGISTRATION,
    }
    const [pageView, setPageView] = useState(PageView.LOGIN)


    const renderPageContent = () => {

        switch (pageView) {
            case PageView.LOGIN:
                return <WithAuthLoginComponent
                    texts={texts}
                    locale={locale}
                    configInfo={configInfo}
                    goToRegistration={() => setPageView(PageView.REGISTRATION)}
                    goToFreePath={goToFreePath}
                    tenantMessageElement={tenantMessageElement} />
            case PageView.REGISTRATION:
                return <WithAuthRegistrationComponent
                    texts={texts}
                    locale={locale}
                    configInfo={configInfo}
                    goToLogin={() => setPageView(PageView.LOGIN)}
                    tenantMessageElement={tenantMessageElement} />
        }
    };


    return renderPageContent();
}

export default WithAuthComponent;